import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

function requireAuth (to, from, next) {

  function checkPermission () {
    const permissions = store.getters.authPermissions;

    if (permissions.length == 0) {
      store.dispatch('getUserInfo')
      .then(() => {
        checkPermission();
      });
    } else {
      const userCan = permissions.includes(to.matched[0].meta.permission);

      if (userCan) {
        next();
      } else {
        next('/permission-denied');
      }
    }
  }

  if (store.getters.isLoggedIn) {
    if (to.matched.some(record => record.meta.permission)) {
      checkPermission();
    } else {
      next();
    }
  } else {
    next('/login');
  }
}

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'transfers.index' },
      beforeEnter: requireAuth,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      beforeEnter: requireAuth,
      meta: {
        permission: 'enter_board',
      },
      component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue')
    },
    {
      path: '/transfers',
      name: 'transfers.index',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "transfers.index" */ './views/Transfers.vue')
    },
    {
      path: '/transfers/create',
      name: 'transfers.create',
      beforeEnter: requireAuth,
      meta: {
        permission: 'create_transfer'
      },
      component: () => import(/* webpackChunkName: "transfers.create" */ './views/TransferRequest.vue')
    },
    {
      path: '/transfers/:id',
      name: 'transfers.show',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "transfers.show" */ './views/TransferDetails.vue')
    },
    {
      path: '/service-records',
      name: 'service_records.index',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "service_records.index" */ './views/ServiceRecords.vue')
    },
    {
      path: '/service-records/create',
      name: 'service_records.create',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "service_records.create" */ './views/ServiceRecordCreate.vue')
    },
    {
      path: '/service-records/:id',
      name: 'service_records.show',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "service_records.show" */ './views/ServiceRecordDetails.vue')
    },
    {
      path: '/users',
      name: 'users.index',
      beforeEnter: requireAuth,
      meta: {
        permission: 'list_users'
      },
      component: () => import(/* webpackChunkName: "users.index" */ './views/Users.vue')
    },
    {
      path: '/users/create',
      name: 'users.create',
      beforeEnter: requireAuth,
      meta: {
        permission: 'create_user'
      },
      component: () => import(/* webpackChunkName: "users.create" */ './views/UserCreateOrDetails.vue')
    },
    {
      path: '/users/:id',
      name: 'users.show',
      beforeEnter: requireAuth,
      meta: {
        permission: 'edit_user'
      },
      component: () => import(/* webpackChunkName: "users.show" */ './views/UserCreateOrDetails.vue')
    },
    {
      path: '/board',
      name: 'board',
      beforeEnter: requireAuth,
      meta: {
        permission: 'enter_board'
      },
      component: () => import(/* webpackChunkName: "board" */ './views/Board.vue')
    },
    {
      path: '/shuttle-list',
      name: 'shuttle_list',
      beforeEnter: requireAuth,
      meta: {
        permission: 'shuttle_list'
      },
      component: () => import(/* webpackChunkName: "shuttle_list" */ './views/ShuttleList.vue')
    },
    {
      path: '/shuttle-create',
      name: 'shuttle_create',
      beforeEnter: requireAuth,
      meta: {
        permission: 'shuttle_create'
      },
      component: () => import(/* webpackChunkName: "shuttle_create" */ './views/ShuttleCreateOrUpdate.vue')
    },
    {
      path: '/shuttle/:id',
      name: 'shuttle_detail',
      beforeEnter: requireAuth,
      meta: {
        permission: 'shuttle_create'
      },
      component: () => import(/* webpackChunkName: "shuttle_detail" */ './views/ShuttleCreateOrUpdate.vue')
    },
    {
      path: '/shuttle-register-list',
      name: 'shuttle_register_list',
      beforeEnter: requireAuth,
      meta: {
        permission: 'shuttle_register_list'
      },
      component: () => import(/* webpackChunkName: "shuttle_register_list" */ './views/ShuttleRegisterList.vue')
    },
    {
      path: '/shuttle-register',
      name: 'shuttle_register',
      beforeEnter: requireAuth,
      meta: {
        permission: 'shuttle_register'
      },
      component: () => import(/* webpackChunkName: "shuttle_register" */ './views/ShuttleRegister.vue')
    },
    {
      path: '/vehicles',
      name: 'vehicles.index',
      beforeEnter: requireAuth,
      meta: {
        permission: 'cars_list'
      },
      component: () => import(/* webpackChunkName: "vehicles.index" */ './views/CarsList.vue')
    },
    {
      path: '/specifications',
      name: 'specifications.index',
      beforeEnter: requireAuth,
      meta: {
        permission: 'create_specification'
      },
      component: () => import(/* webpackChunkName: "specifications.index" */ './views/Specifications.vue')
    },
    {
      path: '/specifications/:id/edit',
      name: 'specifications.edit',
      beforeEnter: requireAuth,
      meta: {
        permission: 'edit_specification'
      },
      component: () => import(/* webpackChunkName: "specifications.edit" */ './views/SpecificationCreateOrDetails.vue')
    },
    {
      path: '/specifications/create',
      name: 'specifications.create',
      beforeEnter: requireAuth,
      meta: {
        permission: 'create_specification'
      },
      component: () => import(/* webpackChunkName: "specifications.create" */ './views/SpecificationCreateOrDetails.vue')
    },
    {
      path: '/vehicle-types',
      name: 'vehicle_types.index',
      beforeEnter: requireAuth,
      meta: {
        permission: 'create_specification'
      },
      component: () => import(/* webpackChunkName: "vehicle-types.index" */ './views/VehicleTypes.vue')
    },
    // {
    //   path: '/vehicle-types/create',
    //   name: 'vehicle_types.create',
    //   beforeEnter: requireAuth,
    //   meta: {
    //     permission: 'create_specification'
    //   },
    //   component: () => import(/* webpackChunkName: "vehicle-types.create" */ './views/VehicleTypeCreate.vue')
    // },
    {
      path: '/departments',
      name: 'departments.index',
      beforeEnter: requireAuth,
      meta: {
        permission: 'create_specification'
      },
      component: () => import(/* webpackChunkName: "departments.index" */ './views/Departments.vue')
    },
    {
      path: '/departments/create',
      name: 'departments.create',
      beforeEnter: requireAuth,
      meta: {
        permission: 'create_specification'
      },
      component: () => import(/* webpackChunkName: "departments.create" */ './views/DepartmentCreate.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue')
    },
    {
      path: '/settings/general',
      name: 'settings.general',
      beforeEnter: requireAuth,
      meta: {
        permission: 'update_settings'
      },
      component: () => import(/* webpackChunkName: "settings.general" */ './views/Settings.vue'),
      props: {
        group: 'general',
      },
    },
    {
      path: '/settings/transfer',
      name: 'settings.transfer',
      beforeEnter: requireAuth,
      meta: {
        permission: 'update_settings'
      },
      component: () => import(/* webpackChunkName: "settings.transfer" */ './views/Settings.vue'),
      props: {
        group: 'transfer',
      },
    },
    {
      path: '/full-page/',
      component: () => import(/* webpackChunkName: "full-page" */ './views/FullPage.vue'),
      children: [
        {
          path: '/transfers/:id/print',
          name: 'transfers.print',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "transfers.show" */ './views/TransferPrint.vue'),
          props: { isInCard: false }
        },
        {
          path: '/login/',
          name: 'login',
          component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/Login.vue'),
          meta: {
            guest: true,
          }
        },
        {
          path: '/password-reset/:token/:email/:host',
          name: 'passwordReset',
          component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/PasswordReset.vue'),
          meta: {
            guest: true,
          }
        },
        {
          path: '/error-in-card',
          name: 'error-in-card',
          component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/Error.vue')
        },
        {
          path: '/permission-denied',
          name: 'permission-denied',
          component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/Error.vue'),
          props: { isInCard: false }
        },
        {
          path: '/lock-screen',
          name: 'lock-screen',
          component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/LockScreen.vue'),
        },
        {
          path: '/404',
          name: 'not-found',
          component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/NotFound.vue'),
          props: { isInCard: false }
        }
      ]
    },
    { path: '*', redirect: '/404' },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
